import i18n from "@/plugins/i18n"
import abilities from "@/composables/abilities";
import moduleAbilities from "@/composables/moduleAbilities";
import { computed } from "vue";

const eventGroup = [
    'events-index', 'events-view', 'events-register', 'events-form-update', 'events-form-preview', 'events-planning-view',
    'events-nps', 'events-nps-index', 'events-nps-create', 'events-nps-preview', 'events-nps-view', 'events-nps-details',
    'events-nps-responses', 'events-nps-responses-details', 'events-nps-statistics']

export default {
    menus:  computed(()=>(
        {
            sectionTitle: 'EVENT',
            module : [moduleAbilities.EVENT_PORTAL],
            permission: [],
            children: [
                {
                    title: i18n.global.t('menu.events.title'),
                    icon: 'fa fa-users icon-right2',
                    route: 'events-index',
                    group: eventGroup,
                    id: 'step-events',
                    permission: [abilities.CAN_VIEW_EVENT, abilities.CAN_VIEW_ALL_EVENT],
                    children: [],
                    module: [moduleAbilities.EVENT_PORTAL],
                },
            ]
        }
    ))

}
